import store from "../store"

const defaultState = {
    byFloorId: {
        [undefined]: {
            byIds: {},
            allIds: []
        }
    }
} 

const reviewsReducer = (state = defaultState, action) => {
    switch(action.type) {
        case "REVIEW_FLOOR_SUCCESS":
            let { review } = action.payload.data;
            if (!state.byFloorId[review.woo_product_id]) state.byFloorId[review.woo_product_id] = {
                byIds: {},
                allIds: []
            }
            if (state.byFloorId[review.woo_product_id].allIds.indexOf(review.id) === -1){
                state.byFloorId[review.woo_product_id].allIds = [review.id,...state.byFloorId[review.woo_product_id].allIds]
            }
            state.byFloorId[review.woo_product_id].byIds[review.id] = review;
            return { ...state, byFloorId: { ...state.byFloorId } }
        case "GET_REVIEWS_REQUEST": 
            return { ...state, loading: true }
        case "GET_REVIEWS_SUCCESS":
            let { reviews } = action.payload.data
            for (let review of reviews) {
                if (!state.byFloorId[review.woo_product_id]) state.byFloorId[review.woo_product_id] = { allIds:[], byIds: {}}
                state.byFloorId[review.woo_product_id].byIds[review.id] = review
                if (state.byFloorId[review.woo_product_id].allIds.indexOf(review.id) === -1) state.byFloorId[review.woo_product_id].allIds.push(review.id);
            }
            return { 
                error: undefined, 
                loading: false, 
                byFloorId: { ...state.byFloorId }
            }
        case "GET_REVIEWS_FAILED":
            return { error: action.error, loading: false, byFloorId: { ...state.byFloorId } }
        default:
            return state;
    }
}

export default reviewsReducer;